/* eslint-disable @typescript-eslint/no-explicit-any */
type AnyRecord = Record<string, any>;

type TimelineItem =
  | {
      kind: "revision_block";
      occurred_at: string | null;
    }
  | {
      kind: "log";
      occurred_at: string | null;
      log: AnyRecord;
      parent: AnyRecord;
      revision?: AnyRecord | null;
    };

const toIsoOrNull = (v: any) => (typeof v === "string" && v.length ? v : null);

const hasArray = (v: any) => Array.isArray(v) && v.length > 0;

export function buildTimeline(items: AnyRecord[]): TimelineItem[] {
  const safeItems = Array.isArray(items) ? items : [];

  const revisionById = new Map<string, AnyRecord>();
  for (const it of safeItems) {
    const revisions = Array.isArray(it?.revisions) ? it.revisions : [];
    for (const rev of revisions) {
      const rid = rev?.revision_id;
      if (typeof rid === "string" && rid) revisionById.set(rid, rev);
    }
  }

  const timeline: TimelineItem[] = [];

  for (const it of safeItems) {
    if (hasArray(it?.revisions)) {
      timeline.push({
        kind: "revision_block",
        occurred_at: toIsoOrNull(it?.occurred_at),
        ...it,
      });
    }

    const logs = Array.isArray(it?.logs) ? it.logs : [];
    for (const log of logs) {
      const subjectType = log?.subject_type;
      const subjectId = log?.subject_id;

      const linkedRevision =
        subjectType === "revision" && typeof subjectId === "string"
          ? (revisionById.get(subjectId) ?? log?.subject ?? null)
          : null;

      timeline.push({
        kind: "log",
        occurred_at: toIsoOrNull(log?.created_at ?? it?.occurred_at),
        ...log,
        parent: it,
        ...linkedRevision,
      });
    }
  }

  timeline.sort((a, b) => {
    const da = Date.parse(a.occurred_at ?? "") || 0;
    const db = Date.parse(b.occurred_at ?? "") || 0;
    return db - da;
  });

  return timeline;
}
